import * as types from '../actions/_actionTypes';
import initialState from './_initialReducerState';

export function apiTokenReducer(state = initialState.apiToken, action: any) {
  switch (action.type) {
    case types.SAVE_AUTH_APITOKEN_SUCCESS:
      return action.apiToken;
    default:
      return state;
  }
}

export function accountReducer(state = initialState.account, action: any) {
  switch (action.type) {
    case types.SAVE_AUTH_ACCOUNT_SUCCESS:
      return action.account;
    default:
      return state;
  }
}

export function profileReducer(state = initialState.profile, action: any) {
  switch (action.type) {
    case types.SAVE_AUTH_PROFILE_SUCCESS:
      return action.profile;
    default:
      return state;
  }
}

export function isAuthReducer(state = initialState.isAuth, action: any) {
  switch (action.type) {
    case types.SAVE_AUTH_ISAUTH_SUCCESS:
      return action.isAuth;
    default:
      return state;
  }
}
